import { userConstants } from '../constants/user.constants';
import { message, notification } from 'antd';
import { queryClient } from '../queryClient';
import { userService } from '../_services';
import { alertActions } from './alert.actions';
import { parseUser } from '../helpers/dspx-utils';
import subscribeWebUser from "../subscription"
import { actions as socketioActions } from './socketio.actions';
import { authHeader } from '../helpers/auth-header';
import { client } from '.';

export const userActions = {
  login,
  logout,
  refresh,
  loadUserEmail,
  authenticateWithCheckTwofact,
  authenticateWithCheckVerificationCode,
};

function login(username, password) {
    return (dispatch, getState) => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                user => { 
                    dispatch(alertActions.clear());
                    const u = parseUser()
                    if(!u) { return }
                    subscribeWebUser(u.PushId)
                    dispatch(success(user))                    
                    dispatch(socketioActions.connect({user}));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(''+error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function authenticateWithCheckTwofact(username, password, setStep) {
  return (dispatch, getState) => {
    dispatch(request({ username }));
    userService.authenticateWithCheckTwofact(username, password).then(
      (user) => {
        if (user && user.success === false && user.state === 'Blocked') {
          notification.error({
            message: user.message || 'Вход заблокирован',
            duration: 15,
          });
          dispatch(failure(user.message || 'Вход заблокирован'));
          return;
        }
        if (user && (user.success === false || user.state === 'Error')) {
          if (user.message) {
            message.error(user.message);
          }
          dispatch(
            failure(user.message || 'Ошибка. Не верный логин или пароль.')
          );
          return;
        }
        const u = parseUser();
        if (!u) {
          if (user && Array.isArray(user?.verificationTypes)) {
            dispatch({
              type: userConstants.TWOFACT_VERIFICATION_TYPES_RECEIVED,
              payload: user.verificationTypes,
            });
          }
          setStep((prev) => prev + 1);
          return;
        }
        subscribeWebUser(u.PushId)
        dispatch(success(user));
        dispatch(socketioActions.connect({ user }));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error('' + error));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function authenticateWithCheckVerificationCode(username, password, code) {
  return (dispatch, getState) => {
    dispatch(request({ username }));
    return userService
      .authenticateWithCheckVerificationCode(username, password, code)
      .then(
        (user) => {
          if (user && (user.success === false || user.state === 'Error')) {
            if (user.message) {
              message.error(user.message);
            }
            dispatch(failure(user.message || 'Ошибка подтверждения кода'));
            return {
              success: false,
              counter: user.counter,
              message: user.message,
            };
          }

          const u = parseUser();
          if (!u) {
            return { success: false };
          }
          subscribeWebUser(u.PushId);
          dispatch(success(user.token));
          dispatch(socketioActions.connect({ user }));
          return { success: true };
        },
        (error) => {
          dispatch(failure(error));
          const backendMessage =
            (error &&
              error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            '' + error;
          message.error(backendMessage);
          dispatch(alertActions.error('' + backendMessage));
          return { success: false, error: backendMessage };
        }
      );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function refresh(token) {
    return dispatch => {
      dispatch(request({ token }));
  
      userService.refresh(token)
        .then(user => {
          dispatch(success(user));
          dispatch(socketioActions.connect({user}));
        },
          error => {
            dispatch(failure(error))
            dispatch(alertActions.error('' + error));
          }
        );
    };
  
    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
  }
  

function logout() {
    return dispatch => {
      dispatch(socketioActions.disconnect());
      userService.logout();
      dispatch( { type: userConstants.LOGOUT } );
      queryClient.clear()
    }
}

function loadUserEmail() {
  return async (dispatch) => {
    try {
      const response = await client.get('/Profile/info', {
        headers: authHeader(),
      });
      dispatch({
        type: userConstants.EMAIL_LOADED,
        payload: response.data?.email,
      });
    } catch (e) {
      console.error(e);
    }
  };
}